import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CampaignComponent } from './campaign/campaign.component';
import { CampaignEditComponent } from './campaign-edit/campaign-edit.component';
import { QuillModule } from 'ngx-quill';
import { FormsModule } from '@angular/forms';
import { DateTimePickerComponent } from './campaign-edit/date-time-picker/date-time-picker.component';
import { SelectContactListComponent } from './campaign-edit/select-contact-list/select-contact-list.component';
import { CoreModule } from '../core/core.module';
import { ValidateTokenComponent } from './campaign-edit/validate-token/validate-token.component';
import { CampaignStatisticComponent } from './campaign-statistic/campaign-statistic.component';
import { ChartsModule } from 'ng2-charts';
import { ReportsModule } from '../reports/reports.module';



@NgModule({
  declarations: [
    CampaignComponent,
    CampaignEditComponent,
    DateTimePickerComponent,
    SelectContactListComponent,
    ValidateTokenComponent,
    CampaignStatisticComponent
  ],
  imports: [
    CommonModule,
    CoreModule,
    FormsModule,
    ChartsModule,
    ReportsModule,
    QuillModule.forRoot()
  ]
})
export class CampaignsModule { }
